import html2canvas from 'html2canvas'
import { useMemo, useRef } from 'react'
import { downloadFile } from '../utils/downloadFile'

export const useDownloadSnapshot = (filename: string) => {
  const subjectRef = useRef<HTMLDivElement>(null)

  const downloadFilename = useMemo(() => {
    if (filename.match(/\.png$/)) {
      return filename
    }

    return `${filename.replaceAll(' ', '_')}.png`
  }, [filename])

  return {
    downloadFilename,
    subjectRef,
    downloadSnapshot: () => {
      if (!subjectRef.current) {
        return
      }

      html2canvas(subjectRef.current).then(canvas => {
        const pngData = canvas.toDataURL('image/png').split(',')[1]

        const base64String = atob(pngData)
        const arrayBuffer = new ArrayBuffer(base64String.length)
        const uint8Array = new Uint8Array(arrayBuffer)

        for (let i = 0; i < base64String.length; i++) {
          uint8Array[i] = base64String.charCodeAt(i)
        }

        const blob = new Blob([arrayBuffer], { type: 'image/png' })

        downloadFile({
          blob,
          filename: downloadFilename,
        })
      })
    },
  }
}
